export default __webpack_public_path__ + "static/media/big logo trayi@2x (1).97477861.svg";